import { inject, InjectionToken } from '@angular/core';
import { ProductTourStateStore } from '../models/product-tour';
import { LocalStorageProductTourStateStore } from '../services/local-storage-product-tour-state-store.service';

export const PRODUCT_TOUR_STATE_STORE =
    new InjectionToken<ProductTourStateStore>('ProductTourStateStore', {
        providedIn: 'root',
        factory: () => inject(LocalStorageProductTourStateStore),
    });
